import React from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button, Input, Modal, Select } from 'antd';
import { useCreateVideoDurationMutation, useUpdateVideoDurationMutation } from '../../redux/Api/VideoApiSlice';
import { toast } from 'react-toastify';
import Loader from '../../pages/pages/loader';

const EditCreateVideoDuration = ({ state, open, setOpen, videoDuration }) => {
    const [createVideoDuration, { isLoading: isCreating }] = useCreateVideoDurationMutation()
    const [updateVideoDuration, { isLoading: isUpdating }] = useUpdateVideoDurationMutation()

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            duration: videoDuration?.duration || "",
        },

        validationSchema: Yup.object({
            duration: Yup.string().required("Please Enter Duration"),
        }),
        onSubmit: async (values) => {
            try {
                if (state === "edit") {
                    await updateVideoDuration({ id: videoDuration?.id, data: values }).unwrap()
                    toast.success('Video duration updated successfully')
                }
                if (state === "create") {
                    await createVideoDuration(values).unwrap()
                    toast.success('Video duration created successfully')
                }
                setOpen(false)
            } catch (error) {
                if (error?.data) {
                    const errorMessages = Object.values(error.data).flat()
                    errorMessages.forEach(message => {
                        toast.error(message)
                    })
                } else {
                    toast.error('Failed to save video duration')
                }
            }
        },
    });

    return (
        <Modal
            className='customModal'
            open={open}
            title={state === "edit" ? "Edit Video Duration" : "Add New Video Duration"}
            onCancel={() => setOpen(false)}
            footer={[
                <Button key="back" onClick={() => setOpen(false)}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" loading={isCreating || isUpdating} onClick={() => {
                    if (Object.keys(validation.errors).length !== 0) {
                        Object.keys(validation.errors).map((key) => {
                            toast.error(validation.errors[key]);
                        });
                        return;
                    }
                    validation.handleSubmit();
                }}>
                    Submit
                </Button>
            ]}
        >
            <Loader isLoading={isCreating || isUpdating} />
            <div className=" mb-3">
                <label className="" >Video Duration</label>
                <Input
                    required
                    type="text"
                    name='duration'
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.duration}
                />
            </div>
            
            <div className='flex flex-col'>
                {Object.keys(validation.errors).map((key) => (
                    <p className='text-danger'>{validation.errors[key]}</p>
                ))}
            </div>
        </Modal>
    )
}

export default EditCreateVideoDuration